import { ReactQueryV5 } from "@mindlercare/mindlerapi-client";
const { useQuery } = ReactQueryV5;
import { countryIds } from "@mindlercare/schema";
import { useMindlerApi } from "api/apiv2";
import { getCountryCode } from "helpers/getCountryCode";
import { useSelectedPsychologistIdParam } from "hooks/useSelectedPsychologistParam";
import { useMemo } from "react";

export const useSelectedPsychologist = () => {
  const countryCode = getCountryCode();
  const [selectedPsychologistId] = useSelectedPsychologistIdParam();
  const api = useMindlerApi();
  const result = useQuery(
    api.psychologists.findAll.queryOptions({
      countryId: countryIds[countryCode],
      includeInactive: true,
    }),
  );

  return useMemo(
    () =>
      result.data?.find(
        ({ psychologistId }) => psychologistId === selectedPsychologistId,
      ) ?? null,
    [result.data, selectedPsychologistId],
  );
};
